import { useState, useEffect } from 'react';
import { getAttributePrices } from '../../../utils/priceHelpers';

export function usePriceCalculator(
  actualAttributes: any,
  hasLoaded: boolean,
  configActiveMenu: boolean
) {
  const [actualPrice, setActualPrice] = useState(0);

  function calcPrice() {
    // Read selections from mock attributes (source of truth — never wiped by Redux)
    // and prices directly from products.json
    const prices = getAttributePrices(actualAttributes);
    let total = 0;
    for (const p of prices) {
      total += p.subtotal;
    }
    const finalPrice = Number(total.toFixed(2));
    setActualPrice(finalPrice);
  }

  useEffect(() => {
    calcPrice();
  }, [configActiveMenu]);

  useEffect(() => {
    if (hasLoaded) {
      calcPrice();
    }
  }, [actualAttributes]);

  return actualPrice;
}
